import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { AuditLogEntry } from '../../../../services/audit-log/audit-log.model';
import { DataDisplayComponent, DataDisplayItem, ButtonComponent } from 'htx-ui-library';

@Component({
  selector: 'app-audit-log-detail',
  imports: [CommonModule, TranslocoPipe, DataDisplayComponent, ButtonComponent],
  templateUrl: './audit-log-detail.component.html',
  styleUrl: './audit-log-detail.component.scss'
})
export class AuditLogDetailComponent {

  private translocoService = inject(TranslocoService);

  @Input() entry!: AuditLogEntry;
  @Output() close = new EventEmitter<void>();

  get displayData(): DataDisplayItem[] {
    const t = (key: string) => this.translocoService.translate(key);
    const date = new Date(this.entry.occurredAt).toLocaleString('de-DE');

    const items: DataDisplayItem[] = [
      { label: t('auditLog.column.occurredAt'), value: [date] },
      {
        label: t('auditLog.column.actor'),
        value: [`${this.entry.actorName ?? ''} (${this.entry.actorRole})`],
      },
      {
        label: t('auditLog.column.outcome'),
        value: [t(`auditLog.outcome.${this.entry.outcome}`)],
      },
      {
        label: t('auditLog.column.resourceType'),
        value: [
          this.entry.resourceId
            ? `${this.entry.resourceType} (${this.entry.resourceId})`
            : this.entry.resourceType,
        ],
      },
    ];

    if (this.entry.httpMethod) {
      items.push({ label: t('auditLog.detail.http'), value: [`${this.entry.httpMethod} ${this.entry.httpPath ?? ''}`] });
    }
    if (this.entry.requestId) {
      items.push({ label: t('auditLog.detail.requestId'), value: [this.entry.requestId] });
    }
    if (this.entry.clientIp) {
      items.push({ label: t('auditLog.detail.clientIp'), value: [this.entry.clientIp] });
    }

    return items;
  }

  get detailsJson(): string {
    if (!this.entry.details) return '{}';
    return JSON.stringify(this.entry.details, null, 2);
  }

  onClose(): void {
    this.close.emit();
  }
}
